var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_3033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6786 3.53569V15.3214H1.17857V3.53569H17.6786ZM18.8571 2.35712H0V16.5H18.8571V2.35712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42861 5.89287H16.5V7.07144H9.42861V5.89287ZM9.42861 8.25001H16.5V9.42858H9.42861V8.25001ZM9.42861 10.6072H12.9643V11.7857H9.42861V10.6072ZM6.36432 8.25001H5.89289V8.13215C6.60004 7.89644 7.07146 7.18929 7.07146 6.48215C7.07146 5.53929 6.24646 4.71429 5.30361 4.71429C4.36075 4.71429 3.53575 5.53929 3.53575 6.48215C3.53575 7.30715 4.00718 7.89644 4.71432 8.13215V8.25001H4.24289C3.18218 8.25001 2.35718 9.07501 2.35718 10.1357V12.9643H8.25004V10.1357C8.25004 9.07501 7.42503 8.25001 6.36432 8.25001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_3033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8571,
    height: 18.8571,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.e60ebb5f97cdecf323c814652f6bc0fc.svg";
export { ForwardRef as ReactComponent };